var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99996 7.41115L9.49996 3.07521L9.50248 3.07668L12 1.63281L10 0.500038L0 6.50004V17.5L1.99996 18.9766V7.41115ZM6.25 8.79988L13.5 4.50004L20.5 8.50004L13 12.5L6.25 8.79988ZM5 10V19L12 22.5L12 14L5 10ZM21.5 18.5L14 22.5V14.5021L21.5 10.5V18.5ZM13.25 2.37502L23.25 8.15623V19.7188L13.25 25.5L3.25 19.7188V8.15623L13.25 2.37502Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsInactive);
export default __webpack_public_path__ + "static/media/analyticsInactive.50437ddbbfda2c8251e4b775b5103695.svg";
export { ForwardRef as ReactComponent };